import { PASS_STRENGTH_SUCCESS } from './types';
import zxcvbn from 'zxcvbn';

////////////////////////
// PASSWORD STRENGTH VERIFICATION - form zxcvbn //
////////////////////////

export function clearPassStrength() {
    return function(dispatch) {
        dispatch({ type: PASS_STRENGTH_SUCCESS, item: 0}); 
    }
}

export function setPassStrength(strength) {
    return function(dispatch) {
	    dispatch({ type: PASS_STRENGTH_SUCCESS, payload: zxcvbn(strength).score});
    }
}